import { supabase } from '../supabase/supabaseClient.js';
import { calculateBasicMetrics } from './basicMetricsService.js';

// Servicio especializado en inicialización de métricas
export const initializeCompanyMetrics = async (companyId) => {
  try {
    // Calcular métricas básicas
    const basicMetrics = await calculateBasicMetrics(companyId);
    
    // Preparar registros para insertar en company_dashboard_metrics
    const metricsToInsert = [
      // Métricas de productos
      {
        company_id: companyId,
        metric_name: 'total_productos',
        metric_value: basicMetrics.total_productos,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'productos_activos',
        metric_value: basicMetrics.productos_activos,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Métricas de planes
      {
        company_id: companyId,
        metric_name: 'total_planes',
        metric_value: basicMetrics.total_planes,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'planes_activos',
        metric_value: basicMetrics.planes_activos,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Nuevas métricas de planes específicos
      {
        company_id: companyId,
        metric_name: 'planes_con_sesiones',
        metric_value: basicMetrics.planes_con_sesiones_count,
        metric_data: { 
          planes_detalle: basicMetrics.planes_detalle.planes_con_sesiones,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'planes_con_simulaciones',
        metric_value: basicMetrics.planes_con_simulaciones_count,
        metric_data: { 
          planes_detalle: basicMetrics.planes_detalle.planes_con_simulaciones,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'planes_con_contrataciones',
        metric_value: basicMetrics.planes_con_contrataciones_count,
        metric_data: { 
          planes_detalle: basicMetrics.planes_detalle.planes_con_contrataciones,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_planes_con_actividad',
        metric_value: basicMetrics.total_planes_con_actividad,
        metric_data: { 
          porcentaje_activos: basicMetrics.porcentaje_planes_activos,
          resumen: basicMetrics.planes_detalle.resumen_actividad,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Métricas de conversión
      {
        company_id: companyId,
        metric_name: 'total_sesiones',
        metric_value: basicMetrics.total_sesiones,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_simulaciones',
        metric_value: basicMetrics.total_simulaciones,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_cotizaciones',
        metric_value: basicMetrics.total_cotizaciones,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_contrataciones',
        metric_value: basicMetrics.total_contrataciones,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'contrataciones_pendientes',
        metric_value: basicMetrics.contrataciones_pendientes,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Métricas de pagos
      {
        company_id: companyId,
        metric_name: 'total_ordenes_pago',
        metric_value: basicMetrics.total_ordenes_pago,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'ordenes_pago_pendientes',
        metric_value: basicMetrics.ordenes_pago_pendientes,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_pagos',
        metric_value: basicMetrics.total_pagos,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'pagos_exitosos',
        metric_value: basicMetrics.pagos_exitosos,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Métricas de certificados y suscripciones
      {
        company_id: companyId,
        metric_name: 'total_certificados',
        metric_value: basicMetrics.total_certificados,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_subscriptions',
        metric_value: basicMetrics.total_subscriptions,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'subscriptions_activas',
        metric_value: basicMetrics.subscriptions_activas,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'total_cuotas',
        metric_value: basicMetrics.total_cuotas,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Métricas financieras
      {
        company_id: companyId,
        metric_name: 'monto_total_ordenes',
        metric_value: basicMetrics.monto_total_ordenes,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'monto_total_pagos',
        metric_value: basicMetrics.monto_total_pagos,
        metric_data: { calculated_at: new Date().toISOString() },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Tasas de conversión
      {
        company_id: companyId,
        metric_name: 'tasa_cotizacion_contratacion',
        metric_value: parseFloat(basicMetrics.tasa_cotizacion_contratacion),
        metric_data: { 
          porcentaje: basicMetrics.tasa_cotizacion_contratacion,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      {
        company_id: companyId,
        metric_name: 'tasa_contratacion_pago',
        metric_value: parseFloat(basicMetrics.tasa_contratacion_pago),
        metric_data: { 
          porcentaje: basicMetrics.tasa_contratacion_pago,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      },
      
      // Información de suscripción
      {
        company_id: companyId,
        metric_name: 'subscription_status',
        metric_value: basicMetrics.subscription_status === 'active' ? 1 : 0,
        metric_data: { 
          status: basicMetrics.subscription_status,
          plan: basicMetrics.subscription_plan,
          calculated_at: new Date().toISOString() 
        },
        period_start: new Date().toISOString(),
        period_end: new Date().toISOString()
      }
    ];

    // Limpiar métricas existentes para esta compañía
    const { error: deleteError } = await supabase
      .from('company_dashboard_metrics')
      .delete()
      .eq('company_id', companyId);

    if (deleteError) {
      console.warn('Error al limpiar métricas existentes:', deleteError);
    }

    // Insertar nuevas métricas
    const { data, error } = await supabase
      .from('company_dashboard_metrics')
      .insert(metricsToInsert);

    if (error) throw error;

    console.log(`Métricas inicializadas para compañía ${companyId}: ${metricsToInsert.length} métricas insertadas`);
    
    return {
      success: true,
      companyId,
      metricsCount: metricsToInsert.length,
      metrics: basicMetrics
    };
  } catch (error) {
    console.error(`Error initializing metrics for company ${companyId}:`, error);
    throw error;
  }
};

export const initializeAllCompaniesMetrics = async () => {
  try {
    // Obtener todas las compañías
    const { data: companies, error } = await supabase
      .from('companias')
      .select('id, nombre_corto');
    
    if (error) throw error;
    
    console.log(`Inicializando métricas para ${companies.length} compañías...`);
    
    // Inicializar métricas para cada compañía
    const results = await Promise.allSettled(
      companies.map(company => initializeCompanyMetrics(company.id))
    );
    
    const successful = results.filter(r => r.status === 'fulfilled').length;
    const failed = results.filter(r => r.status === 'rejected').length;
    
    console.log(`Inicialización completada: ${successful} exitosas, ${failed} fallidas`);
    
    return {
      total: companies.length,
      successful,
      failed,
      results
    };
  } catch (error) {
    console.error('Error initializing all companies metrics:', error);
    throw error;
  }
};

export default {
  initializeCompanyMetrics,
  initializeAllCompaniesMetrics
};